export default __webpack_public_path__ + "static/media/bg13.cf3032c5.jpg";